import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConical, Brain, Zap, Smartphone } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-20 px-6 overflow-hidden bg-brand-bg" data-id="element-393">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-purple/5 rounded-full blur-[120px] pointer-events-none" data-id="element-394" />

      <div className="max-w-[900px] mx-auto relative z-10 text-center" data-id="element-395">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6" data-id="element-396">
          <span className="inline-block py-1.5 px-4 border border-brand-cyan rounded-full text-brand-cyan text-xs font-bold tracking-[0.1em] uppercase bg-brand-cyan/10" data-id="element-397">
            🧬 BIO-X 90
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] mb-6 text-white tracking-tight" data-id="element-398">
          El sistema 80/20 para recuperar energía, foco y control biológico en
          90 días
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-brand-muted font-normal leading-relaxed max-w-[750px] mx-auto mb-4" data-id="element-399">
          Un protocolo educativo para ejecutivos, emprendedores y personas de
          alto rendimiento que quieren ordenar sueño, energía, estrés,
          alimentación y suplementación sin rutinas imposibles.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-12" data-id="element-400">
          <span className="inline-block py-2 px-5 rounded-full bg-gradient-to-r from-brand-cyan to-brand-purple text-white text-sm md:text-base font-bold shadow-[0_0_20px_rgba(0,212,170,0.3)]" data-id="element-401">
            🆕 AHORA INCLUYE: App Interactiva BIO-X 90 con protocolo guiado día
            a día
          </span>
        </motion.div>

        {/* 3D Book Hero Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.35,
        ease: 'easeOut'
      }} className="relative flex justify-center mb-12" data-id="element-402">
          <div className="absolute inset-0 bg-brand-cyan/20 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-403" />
          <motion.img src="https://cdn.magicpatterns.com/uploads/u2Fy8NFvwHuciDc1zswQuT/book2.png" alt="BIO-X 90: The 80/20 Longevity Protocol" className="relative w-full max-w-[280px] md:max-w-[340px] drop-shadow-[0_25px_60px_rgba(0,212,170,0.25)]" animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} loading="eager" data-id="element-404" />
        </motion.div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-[800px] mx-auto mb-12" data-id="element-405">
          <div className="flex flex-col items-center" data-id="element-406">
            <span className="font-display text-4xl font-bold text-brand-cyan mb-1" data-id="element-407">
              90
            </span>
            <span className="text-sm text-brand-muted" data-id="element-408">Días de protocolo</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-409">
            <span className="font-display text-4xl font-bold text-brand-purple mb-1" data-id="element-410">
              3
            </span>
            <span className="text-sm text-brand-muted" data-id="element-411">
              Pilares de bienestar
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-412">
            <span className="font-display text-4xl font-bold text-brand-gold mb-1" data-id="element-413">
              30+
            </span>
            <span className="text-sm text-brand-muted" data-id="element-414">
              Herramientas interactivas
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-415">
            <span className="font-display text-4xl font-bold text-brand-cyan mb-1" data-id="element-416">
              100%
            </span>
            <span className="text-sm text-brand-muted" data-id="element-417">Basado en hábitos</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-418">
          <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full max-w-[500px] h-[64px] rounded-2xl bg-gradient-to-r from-brand-cyan to-brand-purple text-white font-bold text-lg hover:scale-[1.02] transition-transform duration-300 shadow-[0_0_30px_rgba(0,212,170,0.4)] hover:shadow-[0_0_40px_rgba(123,104,238,0.6)] animate-gradient-x" data-id="element-419">
            QUIERO EMPEZAR EL PROTOCOLO → $9.63
          </a>
          <p className="mt-4 text-xs text-brand-muted max-w-[400px]" data-id="element-420">
            Acceso inmediato · Producto digital · Garantía 7 días · No sustituye
            consejo médico.
          </p>

          {/* Credibility Line */}
          <div className="mt-8 flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-brand-muted font-medium" data-id="element-421">
            <div className="flex items-center gap-1.5" data-id="element-422">
              <FlaskConical className="w-4 h-4" data-id="element-423" /> Principios estudiados
            </div>
            <div className="flex items-center gap-1.5" data-id="element-424">
              <Brain className="w-4 h-4" data-id="element-425" /> Hábitos medibles
            </div>
            <div className="flex items-center gap-1.5" data-id="element-426">
              <Zap className="w-4 h-4" data-id="element-427" /> Energía diaria
            </div>
            <div className="flex items-center gap-1.5" data-id="element-428">
              <Smartphone className="w-4 h-4" data-id="element-429" /> App incluida
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}